module.exports = __webpack_public_path__ + "static/media/sf-trial-2-wrong.0bb52c22.mp3";